export const vehicles = {
  title: 'Vehicle Management',
  subtitle: 'Manage your fleet of vehicles',
  
  // Actions
  addVehicle: 'Add Vehicle',
  addFirstVehicle: 'Add Your First Vehicle',
  editVehicle: 'Edit Vehicle',
  deleteVehicle: 'Delete Vehicle',
  viewDetails: 'View Details',
  addLocation: 'Add Location',
  locationManagement: 'Location Management',
  
  // Status
  available: 'Available',
  rented: 'Rented',
  maintenance: 'Maintenance',
  
  // Form fields
  make: 'Make',
  model: 'Model',
  year: 'Year',
  color: 'Color',
  category: 'Category',
  transmission: 'Transmission',
  fuelType: 'Fuel Type',
  seats: 'Seats',
  pricePerDay: 'Price per Day',
  features: 'Features',
  description: 'Description',
  images: 'Images',
  location: 'Vehicle Location',
  selectLocation: 'Select a location',
  selectLocations: 'Select locations',
  locationRequired: 'Please select at least one location',
  
  // Table headers
  image: 'Image',
  availability: 'Available',
  pricePerDayShort: 'Price/Day',
  statusHeader: 'Status',
  
  // Column settings
  columnSettings: 'Column Settings',
  basicInformation: 'Basic Information',
  vehicleDetails: 'Vehicle Details',
  maintenanceLegal: 'Maintenance & Legal',
  systemInformation: 'System Information',
  
  // Bulk actions
  bulkActions: 'Actions',
  markAsAvailable: 'Mark Available',
  markAsRented: 'Mark Rented',
  markAsMaintenanceShort: 'Mark in Maintenance',
  exportCsv: 'Export CSV',
  
  // Messages
  vehicleSelectedCount: '{{count}} vehicle(s) selected',
  vehicleDeletedSuccessfully: 'Vehicle deleted successfully',
  vehicleDeletedDesc: 'The vehicle has been removed from your fleet.',
  failedToDeleteVehicle: 'Failed to delete vehicle',
  vehiclesDeletedSuccessfully: '{{count}} vehicles deleted',
  vehiclesDeletedDesc: 'Selected vehicles have been deleted successfully.',
  vehiclesStatusUpdated: '{{count}} vehicles marked as {{status}}',
  vehiclesStatusUpdatedDesc: 'The status of selected vehicles has been updated.',
  vehiclesExported: '{{count}} vehicles exported',
  vehiclesExportedDesc: 'Vehicle data has been exported to CSV.',
  errorOccurred: 'An error occurred. Please try again.',
  statusUpdatedSuccessfully: 'Vehicle status updated',
  statusUpdatedDesc: 'The vehicle status has been updated successfully.',
  failedToUpdateStatus: 'Failed to update vehicle status',
  failedToUpdateStatusDesc: 'There was an error updating the vehicle status.',
  
  // Empty states
  noVehiclesFound: 'No vehicles found',
  noVehiclesFoundDesc: 'Try modifying your search criteria or filters to see more results.',
  
  // Registration number
  registrationNumber: 'Registration Number',
  registrationRequired: 'Registration number is required',
  registrationInvalid: 'Registration number must contain more than 3 characters',
  
  // Image upload
  vehicleImages: 'Vehicle Images (Max 6)',
  clickToAddImages: 'Click to add images',
  dragDropImages: 'Or drag and drop your images here',
  imageFormats: 'PNG, JPG up to 6 images',
  addImageButton: 'Add',
  
  // Features
  featuresAndOptions: 'Features and Options',
  addAll: 'Add All',
  noFeaturesSelected: 'No features selected',
  clickToAddQuickly: 'Click to add quickly:',
  enterFeature: 'Enter feature name',
  
  // Features list
  featuresList: {
    airConditioning: 'Air Conditioning',
    powerSteering: 'Power Steering',
    centralLocking: 'Central Locking',
    electricWindows: 'Electric Windows',
    radio: 'Radio',
    gpsNavigation: 'GPS/Navigation',
    bluetooth: 'Bluetooth',
    backupCamera: 'Backup Camera',
    parkingSensors: 'Parking Sensors',
    heatedSeats: 'Heated Seats',
    sunroof: 'Sunroof',
    alloyWheels: 'Alloy Wheels',
    ledHeadlights: 'LED Headlights',
    cruiseControl: 'Cruise Control',
    premiumAudio: 'Premium Audio System',
    usbAux: 'USB/AUX',
    keylessStart: 'Keyless Start',
    sideAirbags: 'Side Airbags',
    abs: 'ABS',
    esp: 'ESP',
    brakeAssist: 'Brake Assist',
    blindSpotDetection: 'Blind Spot Detection',
    laneAssist: 'Lane Departure Warning',
    heatedWindshield: 'Heated Windshield',
    electricMirrors: 'Electric Mirrors'
  },
  
  // Maintenance
  maintenanceInformation: 'Maintenance Information',
  registrationNumberRequired: 'Registration Number *',
  currentMileage: 'Current Mileage',
  insuranceExpiry: 'Insurance Expiry',
  insuranceExpiryShort: 'Insurance Expiry',
  technicalControlExpiry: 'Technical Control Expiry',
  technicalControlExpiryShort: 'Technical Control Expiry',
  circulationPermitExpiry: 'Circulation Permit Expiry',
  circulationPermitExpiryShort: 'Circulation Permit Expiry',
  oilChangeDueDate: 'Next Oil Change',
  lastOilChange: 'Last Oil Change',
  lastOilChangeShort: 'Last Oil Change',
  lastOilChangeMileage: 'Last Oil Change Mileage',
  lastOilChangeMileageShort: 'Last Oil Change Mileage',
  oilChangeInterval: 'Oil Change Interval (km)',
  oilChangeIntervalShort: 'Oil Change Interval (km)',
  maintenanceNotes: 'Maintenance Notes',
  maintenanceNotesShort: 'Maintenance Notes',
  
  // System fields
  createdAt: 'Created Date',
  updatedAt: 'Last Modified',
  actions: 'Actions',
  
  // Color search
  searchColor: 'Type to search for a color...',
  
  // Brand and model search
  searchBrand: 'Type to search for a brand...',
  selectModel: 'Select a model...',
  selectBrandFirst: 'Select a brand first',
  
  // Error messages
  correctErrors: 'Please correct the following errors:',
  yearInvalid: 'Year must be between 1900 and 2030',
  seatsInvalid: 'Number of seats must be between 1 and 15',
  mileageInvalid: 'Mileage cannot be negative',
  oilChangeMileageInvalid: 'Oil change mileage cannot be negative',
  oilChangeMileageGreaterThanCurrent: 'Last oil change mileage cannot be greater than current mileage',
  oilChangeIntervalInvalid: 'Oil change interval must be at least 1000 km',
  oilChangeDateInvalid: 'Last oil change date cannot be in the future',
  failedToUploadImage: 'Failed to upload image {{fileName}}: {{error}}',
  
  // Form actions
  clearAll: 'Clear All',
  clearForm: 'Clear Form',
  clearFormMessage: 'Are you sure you want to clear all form data? This action cannot be undone.',
  
  // Validation messages
  makeRequired: 'Make is required',
  modelRequired: 'Model is required',
  colorRequired: 'Color is required',
  categoryRequired: 'Category is required',
  transmissionRequired: 'Transmission type is required',
  fuelTypeRequired: 'Fuel type is required',
  priceRequired: 'Price per day is required',
  
  // Categories
  categories: {
    economy: 'Economy',
    compact: 'Compact',
    midsize: 'Midsize',
    fullsize: 'Full Size',
    luxury: 'Luxury',
    suv: 'SUV',
    convertible: 'Convertible',
  },
  
  // Transmission types
  automatic: 'Automatic',
  manual: 'Manual',
  
  // Fuel types
  fuelTypes: {
    gasoline: 'Gasoline',
    diesel: 'Diesel',
    hybrid: 'Hybrid',
    electric: 'Electric',
    lpg: 'LPG'
  },
  
  // Status labels
  status: {
    available: 'Available',
    rented: 'Rented',
    maintenance: 'Maintenance',
  },
  
  // Messages
  noVehicles: 'No Vehicles Found',
  noVehiclesDesc: 'Add your first vehicle to start managing your fleet.',
  totalVehicles: '{{count}} vehicles found',
  vehicleAdded: 'Vehicle added successfully',
  vehicleUpdated: 'Vehicle updated successfully',
  vehicleDeleted: 'Vehicle deleted successfully',
  failedToAdd: 'Failed to add vehicle',
  failedToUpdate: 'Failed to update vehicle',
  permissionDenied: 'Permission denied. Make sure you have access to vehicle management for this agency.',
  duplicateError: 'A vehicle with this information already exists. Please check registration number or other unique fields.',
  constraintError: 'Invalid data provided. Please check all required fields.',
  networkError: 'Network error. Please check your internet connection and try again.',
  
  // Actions
  delete: 'Delete',
  deleteAll: 'Delete All',
  cancel: 'Cancel',
  confirm: 'Confirm',
  deleteConfirmTitle: 'Delete Vehicle',
  deleteConfirmMessage: 'Are you sure you want to delete this vehicle? This action is irreversible.',
  deleteAllConfirmTitle: 'Delete Selected Vehicles',
  deleteAllConfirmMessage: 'Are you sure you want to delete the {{count}} selected vehicles? This action is irreversible.',
  
  // Filters
  allCategories: 'All Categories',
  allTransmissions: 'All Transmissions',
  allStatuses: 'All Statuses',
  searchPlaceholder: 'Search by make, model or year...',
  
  // Additional placeholders
  selectDate: 'Select date',
  enterRegistrationNumber: 'Ex: ABC-123-45 (required)',
  enterMileage: 'Ex: 50000',
  enterLastServiceMileage: 'Ex: 45000',
  enterMaintenanceNotes: 'Maintenance notes, repairs, etc...',
}; 